import api from '../lib/api'

// eTelecom ZBS Zalo OA integration (tenant-side). The eTelecom "shop" itself
// is created by an admin (separate app/repo) before any of this is usable;
// these calls only read status / kick off the OA authorization flow for a
// shop that already exists.

export const getEtelecomZbsOaStatus = (tenantId, botId) =>
  api.get(`/manager/${tenantId}/etelecom/zbs/oa-status`, { params: { bot_id: botId } }).then(r => r.data)

export const connectEtelecomZbsOa = (botId) =>
  api.post('/auth/etelcom/zalo-connect', { bot_id: botId }).then(r => r.data)

// Phase 4 — Send ZNS. `bot_id` picks which branch/OA to send through (same
// identifier-space note as above). Message status lookup/list moved to the
// admin app (ai-receptionist-bot/frontend) -- see admin_etelecom_zbs_messages.py.

export const sendEtelecomZbsZns = (tenantId, { botId, phone, templateId, templateData }) =>
  api.post(`/manager/${tenantId}/etelecom/zbs/send`, {
    bot_id: botId,
    phone,
    template_id: templateId,
    template_data: templateData || {},
  }).then(r => r.data)

// Read-only mirror of the admin template list (app/routers/admin_etelecom_zbs_templates.py) --
// no create/sync from the tenant side, that stays admin-only.
export const listEtelecomZbsTemplates = (tenantId, botId) =>
  api.get(`/manager/${tenantId}/etelecom/zbs/templates`, { params: { bot_id: botId } }).then(r => r.data)
